import {useAppDispatch, useAppSelector} from '../../../../redux/hooks';
import {RootState} from '../../../../redux/store';
import Button from '../../../../Atoms/Button';
import {BorderColorSharp, DeleteOutlineSharp} from '@mui/icons-material';
import {addNewItem, changeItem, removeItem} from '../../../../redux/slices/character/characterSlice';
import {TextEditor} from '../../../../Atoms/TextEditor';
import {VeneList} from "../../../../Atoms/VeneList";
import {Item} from "../../../../redux/slices/character/characterType";
import React from "react";
import {PopUp} from "../../../../Atoms/PopUp";

export const KampagneInventory = () => {
    const inventar = useAppSelector((state: RootState) => state.character.CharacterSheet.Item);
    const dispatch = useAppDispatch();

    const [isEditDialogOpen, setIsEditDialogOpen] = React.useState<boolean>(false);
    const [itemEditEntry, setItemEditEntry] = React.useState<Item>({
        itemId: 0,
        itemDescription: "",
        itemAmount: 0
    });
    
    const addItem = async () => {
        await dispatch(addNewItem())
        const newItem = document.getElementById(`item-container-${inventar.length - 1}`);
        if (newItem) {
            newItem.scrollIntoView(true);
        }
    }

    return (
        <div className='character_inventory_main'>
            { isEditDialogOpen && (
                <PopUp onClose={ () => {
                    dispatch(changeItem({
                        itemId: itemEditEntry.itemId,
                        itemAmount: itemEditEntry.itemAmount,
                        itemDescription: itemEditEntry.itemDescription
                    }))
                    setIsEditDialogOpen(false)
                } } title="Inventar Eintrag bearbeiten">
                    <div className='character_inventory_item_container'>
                        <div className='character_inventory_item_desc'>
                            <label>Beschreibung:</label>
                            <TextEditor className='inventory-editor' value={itemEditEntry.itemDescription}
                                        onChange={(value) => setItemEditEntry({
                                            ...itemEditEntry,
                                            itemDescription: value
                                        })}/>
                        </div>
                        <div className='character_inventory_item_amount'>
                            <label>Menge: </label>
                            <input className='number-input' type='number' value={itemEditEntry.itemAmount}
                                   onChange={(e: any) => setItemEditEntry({
                                       ...itemEditEntry,
                                       itemAmount: Number(e.target.value)
                                   })}/>
                        </div>
                    </div>
                </PopUp>
            ) }
            <div>
                <Button onClick={async () => await addItem()}>Item hinzufügen</Button>
            </div>
            <VeneList<Item>
                data={inventar}
                colDefinition={[
                    {
                        colName: "Beschreibung",
                        keyName: "itemDescription",
                    },
                    {
                        colName: "Anzahl",
                        keyName: "itemAmount"
                    }
                ]}
                buttonConfig={[
                    {
                        icon: <BorderColorSharp/>,
                        onClick: (dataEntry) => {
                            setItemEditEntry(dataEntry)
                            setIsEditDialogOpen(true);
                        }
                    },
                    {
                        icon: <DeleteOutlineSharp/>,
                        onClick: (dataEntry) => dispatch(removeItem(dataEntry.itemId))
                    }
                ]}
                isFilterDisabled={ true }
            />
        </div>
    )
}